import styled from 'styled-components';

type Props = {
	height: number;
};

const Spacer = styled.div<Props>`
	width: 100%;
	height: ${({ height }) => (height ? `${height}px` : '12px')};
`;

export default Spacer;
